import * as React from "react"
import {Box, Grid, Typography} from "@mui/material";
import {AppLink} from "@ui-seeker/app";
import {BasicTableSeeker, CardSeeker, IconSeeker, ImageSeeker} from "@ui-seeker/core"
import {formatPrice} from "@ui-seeker/utils";

import {imageModalData} from "@signals";
import {useProxiedImage} from "../../../@hooks";
import {productsMatcherImageSizeValue} from "../../@signals";


// Relative "last seen" label (English): today / yesterday / N days ago / N weeks ago / ...
const lastSeenRelative = (dateStr) => {
    if (!dateStr) return '—'
    const d = new Date(dateStr)
    if (isNaN(d.getTime())) return dateStr
    const startOfDay = (x) => { const c = new Date(x); c.setHours(0, 0, 0, 0); return c }
    const days = Math.round((startOfDay(new Date()) - startOfDay(d)) / 86400000)
    if (days <= 0) return 'today'
    if (days === 1) return 'yesterday'
    if (days < 7) return `${days} days ago`
    if (days < 14) return 'last week'
    if (days < 30) return `${Math.floor(days / 7)} weeks ago`
    if (days < 60) return 'last month'
    if (days < 365) return `${Math.floor(days / 30)} months ago`
    return `${Math.floor(days / 365)} year(s) ago`
}


export default function ProductsMatcherTargetProduct({ data={} }) {
    const { decodedURL: ownThumbnail, imageResourceURL, proxyURL } = useProxiedImage(data.ownThumbnail)

    return <CardSeeker elevation={3} sx={{ width: 1, height: 0.8, overflowY: 'auto' }}>
        <Grid container spacing={2}>
            <Grid item xs={3} display="flex" justifyContent="center" alignItems="center">
                <ImageSeeker
                    useSpinner
                    lazyLoad={false}
                    src={imageResourceURL}
                    onError={(e) => { if (proxyURL && !e.target.dataset.fb) { e.target.dataset.fb = '1'; e.target.src = proxyURL } }}
                    sx={{ border: '1px solid', borderColor: 'divider', width: productsMatcherImageSizeValue.value, height: 'auto', cursor: 'pointer' }}
                    onClick={() => imageModalData.value = {
                        title: data.ownTitle,
                        fullSRC: ownThumbnail
                    }}
                />
            </Grid>

            <Grid item xs={9} display="flex" flexDirection="column" alignItems="flex-end">
                { data.ownProductURL
                    ? <AppLink to={data.ownProductURL} target="_blank">
                        <Typography display="flex" alignItems="center" gap={1}>
                            {data.ownTitle}
                            <IconSeeker icon="external-link" sx={{ color: 'text.disabled', fontSize: "0.85rem" }} />
                        </Typography>
                    </AppLink>
                    : <Typography display="flex" alignItems="center">{data.ownTitle}</Typography>
                }
                <Typography color="text.disabled">
                    EAN: {data.ean || "-"}
                </Typography>
                <Typography color="text.disabled">
                    Brand: {data.brand || "-"}
                </Typography>
                <Typography color="text.disabled">
                    Retailer: {data.retailer || "-"}
                </Typography>
                {/* In war2war this panel holds a COMPETITOR listing and the candidates on
                    the right are the customer's own catalog — the mirror of raw2raw. The
                    retailer names above are already truthful, but without saying which
                    direction this is, an operator reads the left panel as "ours". */}
                {data.direction === 'war2war' && (
                    <Typography color="warning.main" sx={{fontWeight: 600}}>
                        Competitor listing → pick the matching OWN product
                    </Typography>
                )}
                <Typography color="text.disabled">
                    Price: {data.ownActualPrice != null ? formatPrice(data.ownActualPrice, data.ownCurrency) : "-"}
                </Typography>
                <Typography color="text.disabled" mb={2}>
                    Last Seen: {lastSeenRelative(data.ownLastSeen)}
                </Typography>
            </Grid>

            <Grid item xs={12}>
                <BasicTableSeeker
                    data={[data]}
                    headers={[[
                        {label: 'Product ID'},
                        {label: 'Variant'},
                        {label: 'Reference'}
                    ]]}
                    columns={[
                        { name: 'ownProductID', render: value => <Box textAlign="center">{value || "-"}</Box> },
                        { name: 'ownVariant', render: value => <Box textAlign="center">{value || "-"}</Box> },
                        { name: 'ownReference', render: value => <Box textAlign="center">{value || "-"}</Box> }
                    ]}
                    cardProps={{ sx: { boxShadow: 0 } }}
                />
            </Grid>
        </Grid>
    </CardSeeker>
}
